var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCourseWizardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.75033 14.8333H7.29199V16.4166H1.75033C0.871575 16.4166 0.166992 15.712 0.166992 14.8333V2.16659C0.166992 1.29575 0.871575 0.583252 1.75033 0.583252H11.2503C12.1291 0.583252 12.8337 1.29575 12.8337 2.16659V8.92742L11.6462 8.27825L11.2503 8.49992V2.16659H7.29199V8.49992L5.31283 6.71867L3.33366 8.49992V2.16659H1.75033V14.8333ZM16.0003 12.4583L11.6462 10.0833L7.29199 12.4583L11.6462 14.8333L16.0003 12.4583ZM8.87533 14.1128V15.6962L11.6462 17.2083L14.417 15.6962V14.1128L11.6462 15.6249L8.87533 14.1128Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourseWizardIcon);
export default __webpack_public_path__ + "static/media/course-wizard-icon.6f940a14.svg";
export { ForwardRef as ReactComponent };